/**
 * @file map
 * @author fuqiang15
 */

export default {
    methods: {
        goToFieldDetail() {
            let serviceId = this.$route.params.serviceId;
            serviceId = serviceId ? `${serviceId}/` : '';
            this.global.redirect({
                url: `/app/service/${serviceId}map/store/detail`,
                type: 'push'
            });
        }
    }
};
